import { DataBean } from "../DataBean";

export class Test extends DataBean {

    public ACTIVE = 1;
    public INACTIVO = 2;
    
       
     public async getProofTestEvaluation(idTest:number): Promise<any> {
        return this.getCustomService("ProofERP", "com.orange.people.proof.bean.Test_getProofTestEvaluation_Number", [
            idTest
        ]);
    }
     public async setResponseProofTest(idTest:number,idAccount:number,response:any): Promise<any> {
        return this.getCustomService("ProofERP", "com.orange.people.proof.bean.Test_setResponseProofTest_Number_Number_java.util.List", [
            idTest,idAccount,response
        ]);
    }
     public async getTestResult(idTestQuestion:number,year:number,month:number): Promise<any> {
        return this.getCustomService("ProofERP", "com.orange.people.proof.bean.Test_getTestResult_Number_Number_Number", [
            idTestQuestion,year,month
        ]);
    }
     public async getProofResponsesByQuesitonAndTest(page:number,rows:number,props:any): Promise<any> {
        return this.getCustomService("ProofERP", "com.advantage.shared.Report_getProofResponsesByQuesitonAndTest_Number_Number_java.util.Map", [
            page,rows,props
        ]);
    }
  
  
   
}
